var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCgLogoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clinical-genomics-logo-orange-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m101 200c55.228 0 100-44.772 100-100 0-55.228-44.772-100-100-100-55.228 0-100 44.772-100 100 0 55.228 44.772 100 100 100z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.293 100) rotate(45) translate(-100.5 -100.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#045c64",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EBEDEF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -23)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.20711,
    y: 67.5,
    width: 137,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.207,
    y: 106.5,
    width: 123,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.21,
    y: 170.5,
    width: 102,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(165.21 173) rotate(90) translate(-165.21 -173)",
    x: 98.707,
    y: 163,
    width: 133,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(127.21 129) rotate(90) translate(-127.21 -129)",
    x: 65.707,
    y: 119,
    width: 123,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(62.207 63.5) rotate(90) translate(-62.207 -63.5)",
    x: -0.79289,
    y: 53.5,
    width: 126,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#045c64",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(3.7071 16) rotate(90) translate(-3.7071 -16)",
    x: -11.793,
    y: 12.5,
    width: 31,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(68.707 54) rotate(90) translate(-68.707 -54)",
    x: 53.207,
    y: 50.5,
    width: 31,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(106.71 119) rotate(90) translate(-106.71 -119)",
    x: 91.207,
    y: 115.5,
    width: 31,
    height: 7
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgLogoGreen);
export default __webpack_public_path__ + "static/media/cg-logo-green.ea260271cb18746b9320ab1db6d98d75.svg";
export { ForwardRef as ReactComponent };